import Swal from "sweetalert2";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

import Fundemas from "../assets/images/Fundemas_Logo1.png";
import ConectaCrecer from "../assets/images/ConectaCrecer_Blanco.png";

function FormPasswordRecover() {
    const { token } = useParams();
    const navigate = useNavigate();

    const { register, handleSubmit, formState: { errors } } = useForm({
        initialValues: {
            email: "",
            password: "",
            password_confirmation: ""
        }
    });

    const sendData = async (data) => {
        let newData = {
            ...data,
            token
        }

        let uri = process.env.REACT_APP_API_URL + 'reset-password';

        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            }
        };

        try {
            let response = await axios.post(uri, newData, config);

            if (response.status === 200) {
                Swal.fire({
                    title: response.data.message,
                    text: 'La contraseña se ha cambiado correctamente',
                    icon: 'success',
                    confirmButtonText: 'Aceptar'
                })
                .then(function () {
                    navigate("/");
                });
            }
        }
        catch (error) {
            if (error.response) {
                Swal.fire({
                    title: 'Hemos encontrado un inconveniente',
                    text: error.response.data.message,
                    icon: 'warning',
                    confirmButtonText: 'Aceptar'
                });
            }
        }
    }

    return (
        <div className="items-center right-6 top-10 py-16 w-auto">
            <div className="rounded-lg overflow-hidden flex justify-center">
                <div className="w-96 rounded-xl border-2 bg-white">
                    <div className="bg-[#AADEE9] flex flex-col items-center rounded-t-xl pt-4">
                        <img src={Fundemas} alt="" className="h-10"/>
                        <img src={ConectaCrecer} alt="" className="h-36"/>                        
                    </div>
                    <h2 className="text-2xl font-bold font-sans mt-4 text-custom-main text-center ">
                        Cambio de Contraseña
                    </h2>
                    <div className="flex items-center px-2">
                        <div className="w-full rounded-2xl border-custom-main">
                            <form className="px-8 py-4" onSubmit={handleSubmit(sendData)}>
                                <div className="text-md flex flex-col items-center justify-between">
                                    <div className="w-full mb-4">
                                        <label htmlFor="email" className="text-[#0D3B66] font-semibold">Correo electrónico</label>
                                        <input id="email" placeholder="Correo electrónico" className="bg-white rounded-2xl border border-[#0D3B66] pl-4 py-2 focus:outline-none w-full" type="email"
                                            {...register("email", {
                                                required: "El correo electrónico es requerido",
                                                pattern: {
                                                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                    message: "El correo electrónico no es válido"
                                                }
                                            })}
                                        />
                                        {errors.email && <span className="text-red-600 w-full text-sm">{errors.email.message}</span>}
                                    </div>
                                    <div className="w-full mb-4">
                                        <label htmlFor="password" className="text-[#0D3B66] font-semibold">Contraseña</label>
                                        <input id="password" placeholder="Ingresa tu contraseña" className="bg-gray rounded-2xl border border-[#0D3B66] pl-4 py-2 focus:outline-none w-full" type="password"
                                            {...register("password", {
                                                required: "La contraseña es requerida",
                                                minLength: {
                                                    value: 8,
                                                    message: "La contraseña debe tener al menos 8 caracteres"
                                                }
                                            })}
                                        />
                                        {errors.password && <span className="text-red-600 w-full text-sm">{errors.password.message}</span>}
                                    </div>
                                    <div className="w-full mb-4">
                                        <label htmlFor="password_confirmation" className="text-[#0D3B66] font-semibold">Confirmar Contraseña</label>
                                        <input id="password_confirmation" placeholder="Confirma tu contraseña" className="bg-gray rounded-2xl border border-[#0D3B66] pl-4 py-2 focus:outline-none w-full" type="password"
                                            {...register("password_confirmation", {
                                                required: "La confirmación de la contraseña es requerida",
                                                validate: value => value === document.getElementById("password").value || "Las contraseñas no coinciden"
                                            })}
                                        />
                                        {errors.password_confirmation && <span className="text-red-600 w-full text-sm">{errors.password_confirmation.message}</span>}
                                    </div>
                                    <button type="submit" className="btn btn-theme">
                                        Recuperar Contraseña
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FormPasswordRecover;